import styled from 'styled-components';

export const Wrapper = styled.section.attrs(props => ({
  id: props.id
}))`
  width: 85%;
  margin: 0 auto;
  padding-top: 50px;
`;

export const CenteredWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

